import { Component, OnInit } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './core/services/theme.service';
import { AuthService } from './core/services/auth.service';
import { IdleService } from './core/services/idle.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styles: [`:host { display: block; height: 100%; }`],
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private themeService: ThemeService,
    private auth: AuthService,
    private idle: IdleService,
  ) {
    this.translate.addLangs(['pt-br', 'en']);
    this.translate.setDefaultLang('pt-br');
  }

  ngOnInit(): void {
    // Subscribe to the user stream so we pick up the preference
    // even when checkAuth() restores the user asynchronously (queueMicrotask).
    this.auth.currentUser$.pipe(
      filter(user => !!user?.preferencias),
      take(1),
    ).subscribe(user => {
      this.translate.use(user!.preferencias!.idioma || 'pt-br');
      this.themeService.setTheme(user!.preferencias!.tema || 'dark');
    });
    this.idle.start();
  }
}
